import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';

const NoticeContainer = styled(View)`
  border-width: 1px;
  border-left-width: 4px;
  border-radius: 4px;
  padding: 12px 16px;
  margin-top: 12px;
  margin-bottom: 12px;
  background-color: ${colors.backgroundAlt};
`;

const NoticeText = styled(Text)`
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
`;

export const Notice = ({ type, children }) => {
  let borderColor = colors.success;  // success/default
  let textColor = colors.text;

  if ('warning' === type) {
    borderColor = colors.warning;
  } else if ('error' === type) {
    borderColor = colors.error;
  } else if ('info' === type) {
    borderColor = colors.info;
  }

  const notices = 'string' === typeof children ? [children] : children;

  return (
    <NoticeContainer style={{ borderColor }}>
      {notices.map(notice => (
        <NoticeText key={notice} style={{ color: textColor }}>{notice}</NoticeText>
      ))}
    </NoticeContainer>
  );
};

export default Notice;
